var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.344183.344183c.458911-.458911 1.202957-.458911 1.661867 0l12.99395 12.993917 12.994-12.993917c.4589-.458911 1.2029-.458911 1.6618 0s.4589 1.202957 0 1.661867l-12.9939 12.99395 12.9939 12.994c.4589.4589.4589 1.2029 0 1.6618s-1.2029.4589-1.6618 0l-12.994-12.9939-12.99395 12.9939c-.45891.4589-1.202956.4589-1.661867 0s-.458911-1.2029 0-1.6618l12.993917-12.994-12.993917-12.99395c-.458911-.45891-.458911-1.202956 0-1.661867z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseWhite);
export default __webpack_public_path__ + "static/media/ico_close_white.98de483a577ab429ef4cbbb6477b13f6.svg";
export { ForwardRef as ReactComponent };